import { get } from 'lodash';

export const getGrades = state => get(state, 'CommonState.grades.data', []);



// WEBPACK FOOTER //
// ./src/state/grades/selectors.js